import { Logger } from '../lib/logger';
import { LoggerNames } from '../lib/constants';
import { IAuthStateManager } from '../auth-state-manager/auth-state-manager';
import { ITokenManager } from '../token-manager/token-manager.types';
import { Service } from './service';

export class AuthStateService implements Service {
  private readonly logger = Logger.createLogger(LoggerNames.AUTH_STATE_SERVICE);
  private readonly authStateManager: IAuthStateManager;
  private readonly tokenManager: ITokenManager;
  private readonly handler = () => {
    this.logger.debug('Token event received, updating auth state.');
    return this.authStateManager.updateAuthState();
  };

  private started = false;

  constructor(tokenManager: ITokenManager, authStateManager: IAuthStateManager<any>) {
    this.tokenManager = tokenManager;
    this.authStateManager = authStateManager;
  }

  async start(): Promise<void> {
    this.logger.debug('Starting AuthStateService');
    await this.authStateManager.updateAuthState();
    this.tokenManager.on('added', this.handler);
    this.tokenManager.on('removed', this.handler);
    this.tokenManager.on('renew-error', this.handler);
    this.tokenManager.on('expired', this.handler);
    this.started = true;
  }
  async stop(): Promise<void> {
    this.logger.debug('Stopping AuthStateService');
    this.tokenManager.off('added', this.handler);
    this.tokenManager.off('removed', this.handler);
    this.tokenManager.off('renew-error', this.handler);
    this.tokenManager.off('expired', this.handler);
    await this.authStateManager.updateAuthState();
    this.started = false;
  }

  canStart(): boolean {
    return !this.started;
  }
  isStarted(): boolean {
    return this.started;
  }
  requiresLeadership(): boolean {
    return false;
  }
}
